import ContentModal from "./Modal";
import Button from "./Button";
import __ from "../utils/getContent";

const ErrorModal = ({
	title,
	errors,
	closeModal,
}: {
	title: string;
	errors?: string[];
	closeModal: () => void;
}) => {
	if (!errors || errors.length === 0) {
		return null;
	}

	return (
		<ContentModal
			isOpen={true}
			closeModal={() => {
				closeModal();
			}}
			contentLabel={__("submission_errors_label", "Form Submission Errors")}
			customStyles={{
				content: {
					bottom: "auto",
					width: "86vw",
					left: "50%",
					position: "fixed",
					right: "auto",
					top: "50%",
					transform: "translate(-50%,-50%)",
					padding: "1rem 2rem",
					borderRadius: "2px",
					maxWidth: "400px",
					boxShadow: "0 0 10px rgba(0,0,0,0.1)",
				},
			}}
		>
			<h1 className="mb-4 text-xl font-bold uppercase">{title}</h1>
			<ul className="mb-8 ml-4 grid list-disc gap-2">
				{errors.map((error, index) => (
					<li key={index} className="text-sm text-red-600">
						{error}
					</li>
				))}
			</ul>
			<Button
				action={() => closeModal()}
				cssClass="mx-auto"
				buttonType="button"
			>
				{__("button_close_text", "Close")}
			</Button>
		</ContentModal>
	);
};
export default ErrorModal;
